import { Badge } from "@src/common/components";
import { PriceScope } from "@api/graphql/generated/generated-types";

interface PriceScopeBadgeProps {
  scope: PriceScope;
}

export function PriceScopeBadge({ scope }: PriceScopeBadgeProps) {
  const scopeLabels: Partial<Record<PriceScope, string>> = {
    [PriceScope.PerOrder]: "Combined mileage",
  };
  const label = scopeLabels[scope];
  if (!label) return null;

  return (
    <div className="mt-1 inline-block">
      <Badge color="info" size="xs" className="inline-block w-fit">
        {label}
      </Badge>
    </div>
  );
}

